import { createInstance as parentCreateInstance } from 'i18next'
import languagedetector from 'i18next-browser-languagedetector'
import backend from 'i18next-http-backend'
import ICU from 'i18next-icu'
import { initReactI18next } from 'react-i18next/initReactI18next'

export function createInstance(
  config: {
    withDetector?: boolean
  } = {},
) {
  const i18nInstance = parentCreateInstance()

  i18nInstance.use(languagedetector)
  i18nInstance.use(backend)
  i18nInstance.use(ICU)
  i18nInstance.use(initReactI18next)


  return i18nInstance
}
